module.exports = __webpack_public_path__ + "img/98.649d8a20.jpg";